import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { LotNotationsButtonComponent } from './lot-notations-button.component';

@NgModule({
  declarations: [LotNotationsButtonComponent],
  imports: [CommonModule, TranslateModule, NzIconModule, NzButtonModule],
  exports: [LotNotationsButtonComponent],
})
export class LotNotationsButtonModule {}
